import { changeVehicleRegistartionInsurance } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';
import { IJeopardy, IServiceResponse } from '@/interfaces';

export interface ApplyRulesRequestOfChangeVehicleRegistrationUpdateModel {
  quoteSessionId?: string;
  requestQuote?: boolean;
  bindChange?: boolean;
  model?: ChangeVehicleRegistrationUpdateModel;
}

export interface ChangeVehicleRegistrationUpdateModel {
  changeEffectiveDate: Date;
  vehicleRegistration: string;
}

export interface ApplyRulesResponseOfChangeVehicleRegistrationViewModel {
  jeopardies: IJeopardy[];
  viewModel: ChangeVehicleRegistrationViewModel;
}

export interface ChangeVehicleRegistrationViewModel {
  changeEffectiveDate: Date;
  vehicleRegistration: string;
}
export const ChangeVehicleService = {
  /**
   * Apply Business Rules
   *
   * @param request
   */
  changeVehicleRegistration(
    quoteSessionId: string,
    vehicleRegistration: string
  ): Promise<IServiceResponse<ApplyRulesResponseOfChangeVehicleRegistrationViewModel>> {
    const request = {
      quoteSessionId: quoteSessionId,
      requestQuote: true,
      bindChange: true,
      model: {
        changeEffectiveDate: new Date(),
        vehicleRegistration: vehicleRegistration,
      },
    };
    return _http.HttpPost(changeVehicleRegistartionInsurance, request);
  },
};
